jQuery.fn.serializeObject = function () {
    var arrayData, objectData;
    arrayData = this.serializeArray();
    objectData = {};

    $.each(arrayData, function () {
        var value;

        if (this.value != null) {
            value = this.value;
        } else {
            value = '';
        }

        if (objectData[this.name] != null) {
            if (!objectData[this.name].push) {
                objectData[this.name] = [objectData[this.name]];
            }

            objectData[this.name].push(value);
        } else {
            objectData[this.name] = value;
        }
    });

    return objectData;
};

let tabsSizes = {}, tabModel = {};

$('.submit-sizing').on('click', function () {
    let form = $(this).parents('form'),
        object = form.serializeObject(), tab = '#'+ $(this).parents('.tab-pane').attr('id');
    form.addClass('was-validated')
    if (form[0].checkValidity() === false) {
        return;
    }
    let rendered = Mustache.render(document.getElementById('each-size').innerHTML, object);
    $(tab +' .product_size-image-wrapper').append(rendered);
    let measurements = '', measurementsArray = [];
    Object.keys(object).forEach(function (key) {
        if (key != 'size') {
            let newObj = { name: key, value: parseFloat(object[key]) };
            measurementsArray[measurementsArray.length] = newObj;
            measurements += Mustache.render(document.getElementById('each-measurement').innerHTML, newObj);
        }
    })
    $(tab +' .product_size-image-wrapper [data-size="' + object.size + '"]').append(measurements);
    $(tab +' .sizeSwatches').append('<li data-size="' + object.size + '" >' + object.size + '</li>');
    form.removeClass('was-validated').find('input').val('');
    tabsSizes[tab] = tabsSizes[tab]  || [];
    tabsSizes[tab][tabsSizes[tab].length] = {
        size: object.size,
        measurements: measurementsArray
    };
});
$('.submit-model').on('click', function(){
    let form = $(this).parents('form'),
        object = form.serializeObject(), tab = '#'+ $(this).parents('.tab-pane').attr('id');
    form.addClass('was-validated')
    if (form[0].checkValidity() === false) {
        return;
    }
    let collect_values = {};
    Object.keys(object).forEach(function (key) {
        $(tab +' .' + key +'.dynamic .value').text(object[key]);
        if(key == 'height') {
            let measurement = object[key];
            if(object[key].indexOf('.') < 0) {
                measurement = measurement.toString().concat('.0');
            }
            measurement = measurement.toString().replace('.','ft ');
            $(tab +' .' + key +'.dynamic .value').text(measurement);
        }
        if(object[key] != '') { 
            collect_values[key] = object[key];
        }
    })
    tabModel[tab] = collect_values;
})
$('.generate').on('click', function(){
    let tab = '#'+ $(this).parents('.tab-pane').attr('id');
    sizingObject = {
        sizing: tabsSizes[tab],
        model: tabModel[tab]
    }
    $(this).parent().find('textarea').val(JSON.stringify(sizingObject));
});
$('.copy_text').on('click', function(){
  var copyText = $(this).parents('.input-group').find('textarea')[0];
  copyText.select();
  copyText.setSelectionRange(0, 99999); 
  document.execCommand("copy");
  $(this).text('Copied!');
  let $this = $(this);
  setTimeout(function(){
      $this.text('Copy');
  }, 1700);
})
$('body').on('click', '.sizeSwatches li:not(.disabled)', function () {
    var size = $(this).data('size');
    $('.sizeSwatches li').removeClass('active');
    $(this).addClass('active');
    $('.product_size-image .product_size-each-size').removeClass('active');
    $('.product_size-image .product_size-each-size[data-size="' + size + '"]').addClass('active')
});